import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import { FeaBaseProcessService } from './fea-base-process.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaPanelRecognitionService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(panelType: string): Promise<any> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      PanelType: panelType
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      const valuesPerElement = await firstValueFrom(this.http.post<Map<number, number>>(environment.API_FEA + `PanelRecognition/GetResult`, request, options));
      var title = `${panelType} Panels`;
      return {
        valuesPerElement: valuesPerElement,
        title: title
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get panel recognition result");
      return null;
    }
  }

}
